// @flow

import { observer } from "mobx-react";
import * as React from "react";

import UserStore from "app/stores/UserStore";

import ValueHelper from "app/util/ValueHelper";

import PageTitle from "app/components/PageTitle/PageTitle";
import Panel from "app/components/Panel/Panel";
import PasswordStrength from "app/components/PasswordStrength/PasswordStrength";
import PasswordConfirmation from "app/components/PasswordConfirmation/PasswordConfirmation";

import "./DashboardPasswordView.scss";

type Props = {
    onChange: Function
};

type State = {
    password: string
};

@observer
export default class DashboardPasswordView extends React.Component<
    Props,
    State
> {
    password: string;

    constructor(props: Props) {
        super(props);
        this.state = { password: "" };

        if (
            UserStore.user == null ||
            ValueHelper.isEmpty(UserStore.user.email)
        ) {
            throw new Error("Not a valid user");
        }
    }

    handleChange = (password: string) => {
        this.setState({ password });
    };

    render() {
        return (
            <div className="DashboardPasswordView">
                <Panel>
                    <PageTitle>
                        <i className="fa fa-key" /> Update Password
                    </PageTitle>

                    <form action="/user/update-password" method="post">
                        <div className="form-group">
                            <label for="password">New Password</label>

                            <PasswordStrength onChange={this.handleChange} />
                        </div>

                        <div className="form-group">
                            <label for="password_confirmation">
                                New Password Confirmation
                            </label>

                            <PasswordConfirmation
                                password={this.state.password}
                            />
                        </div>

                        <footer>
                            <button className="btn btn-primary">
                                <i className="fa fa-check" /> Update Password
                            </button>
                        </footer>
                    </form>
                </Panel>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/dashboard/DashboardPassword/DashboardPasswordView.js